module.exports = __webpack_public_path__ + "img/Anhänger_PF_12t.fe992be2.svg";